export const defaults = {
    title: 'Bild bearbeiten',
};
